import React from "react";
import TermsPrivacyDetails from "src/Components/Customer/TermsPrivacyDetails";
import { faqsContent } from "src/lib/Faqs";
import faqsImage from "src/assets/images/website-images/FAQ-banner.png";

const Faqs = () => {
  return (
    <div>
      <TermsPrivacyDetails
        image={faqsImage}
        title="FAQs"
        content={faqsContent}
      />
    </div>
  );
};

export default Faqs;
